import React from 'react'
import * as styles from './Burger.module.scss'
import Menu from './assets/menu.svg'

interface BurgerProps {
  onClick?: () => void
}
const Burger: React.FC<BurgerProps> = ({ onClick }: BurgerProps) => {
  function handleClick (e: React.MouseEvent | React.TouchEvent) {
    onClick?.()
    e.preventDefault()
  }

  return (
    <button
      className={styles.container}
      onClick={(e) => handleClick(e)}
      onTouchEnd={(e) => handleClick(e)}
    >
      <Menu />
    </button>
  )
}

export default Burger
